export class UpdateModifiedData {
  static readonly type = '[StandarPrediction] Update ModifiedData';
  constructor(public payload: { [key: string]: number }) {}
}

export class SetRowData {
  static readonly type = '[StandarPrediction] Set Row Data';
  constructor(public payload: any[]) {}
}

export class SetActualBase {
  static readonly type = '[StandarPrediction] Set ActualBase';
  constructor(public payload: number) {}
}

export class SetActualFilters {
  static readonly type = '[StandarPrediction] Set ActualFilters';
  constructor(public payload: any[]) {}
}
export class SetEndDate {
  static readonly type = '[StandarPrediction] Set EndDate';
  constructor(public payload: string) {}
}
export class SetInitialDate {
  static readonly type = '[StandarPrediction] Set StartDate';
  constructor(public payload: string) {}
}

export class SetIgnoredDates {
  static readonly type = '[StandarPrediction] Set IgnoresDates';
  constructor(public payload: any) {}
}

export class SetExcludePUDCItems {
  static readonly type = '[StandarPrediction] Set ExcludePUDCItems';
  constructor(public payload: any[]) {}
}

export class SetExcludeRCTDACItems {
  static readonly type = '[StandarPrediction] Set ExcludeRCDTACItems';
  constructor(public payload: any[]) {}
}

export class SetExcludeRCUDCItems {
  static readonly type = '[StandarPrediction] Set ExcludeRCUDCItems';
  constructor(public payload: any[]) {}
}

export class SetDetailRowData {
  static readonly type = '[StandarPrediction] Set DetailRowData';
  constructor(public payload: any) {}
}

export class SetDetailDate {
  static readonly type = '[StandarPrediction] Set DetailDate';
  constructor(public payload: string) {}
}

export class SetResetStore {
  static readonly type = '[StandarPrediction] Set ResetStore';
  constructor() {}
}

export class GetStandartDataDetails {
  static readonly type = '[StandarPrediction] Get Standart Data Details';
  constructor(public payload: any) {}
}

export class SetStandarData {
  static readonly type = '[StandarPrediction] Set Standar Data';
  constructor(public payload: any[]) {}
}

export class GetStandarDataWithBase {
  static readonly type = '[StandarPrediction] Set Standar Data with Base';
  constructor(public payload: { [key: string]: any }) {}
}

export class SetMedidorId {
  static readonly type = '[StandarPrediction] Set Standar selected medidor Id';
  constructor(public medidor: number | null) {}
}
